import { FC, ReactChild, ReactElement } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { InPageNotification } from '@ebsco-ui/ebsco-ui';

import { ShapeWithClassName } from '@app/constants';

import { NotificationVariant } from './constants';

export type NotificationProps = {
  variant: NotificationVariant;
  header?: ReactChild;
  description?: ReactChild | (string | ReactElement)[];
  icon?: IconProp;
};

export const Notification: FC<ShapeWithClassName<NotificationProps>> = ({
  className,
  variant,
  header,
  description,
  icon,
}) => (
  <InPageNotification className={className} variant={variant} icon={icon}>
    {(header as ReactChild) && (
      <InPageNotification.Header data-auto={`notification-${variant}-header`}>
        {header}
      </InPageNotification.Header>
    )}
    {(description as ReactChild) && (
      <InPageNotification.Description
        data-auto={`notification-${variant}-description`}
      >
        {description}
      </InPageNotification.Description>
    )}
  </InPageNotification>
);
